/**
 * The catalogue area's three routes, aggregated.
 *
 * `/search`, `/genres/:slug`, `/tags/:slug` — one feature because they are one
 * surface: the same `GET /results` call, the same grid, the same empty state,
 * differing only in which facet the URL holds.
 *
 * All three are disjoint in their first segment, so the order here is the
 * sitemap's rather than the matcher's.
 */
import type { RouteObject } from 'react-router-dom';

import { browseRoutes } from './browse/browse.routes';
import { searchRoute } from './search/search.route';

export const catalogueRoutes: RouteObject[] = [searchRoute, ...browseRoutes];
